<script lang="ts" module>
  import type { RowPreview } from "./rows.ts";

  export interface ProductTile {
    readonly preview: RowPreview;
    readonly title: string;
    readonly body: string;
    readonly plan: string | null;
    readonly short?: true;
  }

  export interface ProductSection {
    readonly id: string;
    readonly title: string | null;
    readonly lede: string | null;
    readonly tiles: readonly ProductTile[];
  }
</script>

<script lang="ts">
  import SectionHead from "#lib/site/SectionHead.svelte";
  import ShowCard from "#lib/site/ShowCard.svelte";
  import { ENTRANCE_FRAME } from "#lib/ui/recipes.ts";

  let { sections, testId }: { sections: readonly ProductSection[]; testId: string } = $props();
</script>

{#each sections as section, order (section.id)}
  <section
    class={[
      ENTRANCE_FRAME,
      section.title === null ? "pt-4" : order === 0 ? "pt-20 sm:pt-28" : "pt-28 sm:pt-36",
    ]}
    id={section.id}
    data-testid="{testId}-{section.id}"
  >
    {#if section.title !== null}
      <SectionHead align="center" title={section.title} lede={section.lede} />
    {/if}
    <div class={["grid gap-3 lg:grid-cols-2", section.title !== null && "mt-14"]}>
      {#each section.tiles as tile (tile.preview)}
        <ShowCard
          title={tile.title}
          body={tile.body}
          plan={tile.plan}
          preview={tile.preview}
          short={tile.short === true}
          testId="{testId}-{tile.preview}"
        />
      {/each}
    </div>
  </section>
{/each}
